module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Semibold-3926eb65ce4420a819305cdf5dd2bfd6.woff2";